enum SUPPORTED_LANGUAGES {
  'EN' = 'en-us',
  'FR' = 'fr-fr',
}

export const defaultLang = SUPPORTED_LANGUAGES.EN;
